import React from 'react';

import SettingsPageLayoutNE from '../Layout/SettingsPageLayoutNE/SettingsPageLayoutNE';
import EditCompanyCard from './sections/EditCompanyCard/EditCompanyCard';
import EditHoldingCard from './sections/EditHoldingCard/EditHoldingCard';

import './SettingsOrganizationNE.scss';

const SettingsOrganizationNE = () => {
  return (
    <SettingsPageLayoutNE>
      <EditHoldingCard />
      <EditCompanyCard />
    </SettingsPageLayoutNE>
  );
};

export default SettingsOrganizationNE;
